import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import Loader from "../Loader/Loader";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import toast from "react-hot-toast";

const ProductDetails = () => {
  const [selectedPackages, setSelectedPackages] = useState(null);

  const context = useContext(MyContext);
  const { loading, setLoading, getAllResort, getAllResortFunction } = context;

  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();

  const handleDeleteClick = () => {
    setShowPopup(true);
  };

  const deleteResort = async (id) => {
    setLoading(true);
    try {
      await deleteDoc(doc(fireDB, "resorts", id));
      toast.success("Resort deleted successfully");
      getAllResortFunction();
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete resort");
    }
    setLoading(false);
  };

  return (
    <div className="my-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">
            Resort Management
          </h1>
          <p className="text-gray-500 text-sm">
            Manage all listed wedding resorts
          </p>
        </div>

        <Link to="/addproduct">
          <button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-5 py-2.5 rounded-xl shadow-md transition">
            + Add Resort
          </button>
        </Link>
      </div>

      {/* Loading */}
      {loading && (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}

      {/* Product Table */}
      <div className="w-full overflow-x-auto hide-scroll-bar mb-5">
        <table className="min-w-[1600px] w-full text-sm border border-gray-200">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-sm">
              <th className="px-5 py-4 text-left">#</th>
              <th className="px-5 py-4 text-left">Image</th>
              <th className="px-5 py-4 text-left">Resort</th>
              <th className="px-5 py-4 text-left">Location</th>
              <th className="px-5 py-4 text-left">Guests</th>
              <th className="px-5 py-4 text-left">Nights</th>
              <th className="px-5 py-4 text-left">Price</th>
              <th className="px-5 py-4 text-left">Description</th>
              <th className="px-5 py-4 text-left">Facilities</th>
              <th className="px-5 py-4 text-left">Menu</th>
              <th className="px-5 py-4 text-left">Room Rates</th>
              <th className="px-5 py-4 text-left">Inclusions</th>
              <th className="px-5 py-4 text-left">Packages</th>
              <th className="px-5 py-4 text-left">Wedding Budget</th>
              <th className="px-5 py-4 text-left">Actions</th>
            </tr>
          </thead>

          <tbody>
            {getAllResort?.map((item, index) => {
              const {
                id,
                name,
                location,
                guests,
                nights,
                price,
                image,
                gallery,
                description, // ✅ add
                facilities, // ✅ add
                menu,
                roomRates,
                inclusions,
                packages,
                weddingBudget,
              } = item;

              return (
                <tr
                  key={id}
                  className="border-b border-gray-200 hover:bg-gray-50 text-gray-700"
                >
                  <td
                    className="px-5 py-4
"
                  >
                    {index + 1}
                  </td>

                  <td
                    className="px-5 py-4
"
                  >
                    <div className="flex items-center gap-2">
                      {/* Main Image */}
                      {image && (
                        <img
                          src={image}
                          alt="Main"
                          className="h-14 w-20 object-cover rounded-lg border shadow-sm"
                        />
                      )}

                      {/* Gallery Images (max 2 preview) */}
                      <div className="flex -space-x-2">
                        {gallery?.slice(1, 3).map((img, i) => (
                          <img
                            key={i}
                            src={img}
                            alt="Gallery"
                            className="h-10 w-14 object-cover rounded border shadow-sm"
                          />
                        ))}

                        {/* If more images exist */}
                        {gallery?.length > 3 && (
                          <div className="h-10 w-14 bg-gray-200 text-xs flex items-center justify-center rounded border">
                            +{gallery.length - 3}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>

                  <td className="px-5 py-4 font-semibold text-left">{name}</td>
                  <td className="px-5 py-4 text-pink-500">{location}</td>
                  <td className="px-5 py-4">{guests}</td>
                  <td className="px-5 py-4">{nights}</td>
                  <td className="px-5 py-4 text-green-600 font-semibold">
                    ₹{price}
                  </td>
                  {/* Description */}
                  <td className="px-5 py-4 text-left max-w-xs">
                    <div className="text-xs text-gray-600 line-clampx-5 py-4">
                      {description}
                    </div>
                  </td>

                  <td className="px-5 py-4 text-left">
                    <div className="flex flex-wrap gap-1">
                      {(Array.isArray(facilities)
                        ? facilities
                        : facilities?.split(",") || []
                      )
                        .slice(0, 3)
                        .map((f, i) => (
                          <span
                            key={i}
                            className="bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-xs"
                          >
                            {f.trim()}
                          </span>
                        ))}
                    </div>
                  </td>

                  {/* Menu */}
                  <td className="px-5 py-4 text-left">
                    {menu?.slice(0, 2).map((m, i) => (
                      <div
                        key={i}
                        className="text-xs bg-gray-100 px-2 py-1 rounded mb-1"
                      >
                        {m}
                      </div>
                    ))}
                  </td>

                  {/* Room Rates */}
                  <td className="px-5 py-4 text-left">
                    {roomRates?.slice(0, 2).map((r, i) => (
                      <div
                        key={i}
                        className="text-xs bg-gray-100 px-2 py-1 rounded mb-1"
                      >
                        {r}
                      </div>
                    ))}
                  </td>

                  {/* Inclusions */}
                  <td className="px-5 py-4 text-left">
                    {inclusions?.slice(0, 2).map((inc, i) => (
                      <div
                        key={i}
                        className="text-xs bg-gray-100 px-2 py-1 rounded mb-1"
                      >
                        {inc}
                      </div>
                    ))}
                  </td>

                  {/* Packages - Only One Visible */}
                  <td className="px-5 py-4 text-left">
                    {packages?.length > 0 && (
                      <div className="bg-slate-100 p-2 rounded text-xs">
                        <p className="font-semibold">{packages[0].title}</p>
                        <p className="text-rose-600">₹{packages[0].price}</p>
                      </div>
                    )}

                    {packages?.length > 1 && (
                      <button
                        onClick={() => setSelectedPackages(packages)}
                        className="text-blue-600 text-xs mt-2 underline"
                      >
                        View All ({packages.length})
                      </button>
                    )}
                  </td>

                  <td className="px-5 py-4 text-rose-600 font-medium">
                    ₹{weddingBudget}
                  </td>

                  <td className="px-5 py-4">
                    <div className="flex gap-2">
                      <button
                        onClick={() => navigate(`/updateResort/${id}`)}
                        className="px-3 py-1.5 text-xs rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-200 transition"
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => deleteResort(id)}
                        className="px-3 py-1.5 text-xs rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {selectedPackages && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl w-[500px] max-h-[80vh] overflow-y-auto">
              <h2 className="text-lg font-semibold mb-4">All Packages</h2>

              {selectedPackages.map((pkg, i) => (
                <div key={i} className="border p-3 rounded mb-3">
                  <p className="font-semibold">{pkg.title}</p>
                  <p className="text-gray-600 text-sm">{pkg.description}</p>
                  <p className="text-rose-600 font-semibold">₹{pkg.price}</p>
                </div>
              ))}

              <button
                onClick={() => setSelectedPackages(null)}
                className="mt-3 bg-gray-800 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n.hide-scroll-bar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.hide-scroll-bar::-webkit-scrollbar {\n  display: none;\n}\n",
        }}
      />
    </div>
  );
};

export default ProductDetails;
